<template>
  <div>
    <div class="order-confirm">
      <div class="student">
        <img
          class="avatar"
          :src="studentInfo.studentAvatar || 'https://image.xiaomaiketang.com/xm/fwxmf84s8n.png'"
          alt
        />
        <span class="name">{{studentInfo.studentName}}</span>
      </div>
      <div class="info">
        <div class="inst">
          <span class="icon iconfont">&#xe60c;</span>
          <span class="word">{{studentInfo.instName}}</span>
        </div>
        <div class="box">
          <div @click="selectPrice" class="select-price">
            <span class="icon iconfont">&#xe611;</span>
          </div>
          <img
            class="image"
            :src="(commodityDetail.coverResource || {}).resUrl || 'https://image.xiaomaiketang.com/xm/kNYEN5Qiw6.png'"
            alt
          />
          <div class="detail">
            <span class="name">{{commodityDetail.commodityName}}</span>
            <div class="unit">
              <span
                class="number"
              >{{(currentPrice.commoditySpecs || {}).containQuantity}}{{(currentPrice.commoditySpecs || {}).measurementUnits}}</span>
              <span class="price">¥{{moneyFormatGroup(currentPrice.currentPrice, 2)}}</span>
            </div>
          </div>
        </div>
        <div class="coupon-content" @click="handleShowChooseCoupon">
          <div class="coupon-content-inner">
            <div class="coupon-content-text">使用优惠券</div>
            <div class="coupon-content-name gray" v-if="validCouponList.length === 0">暂无可用</div>
            <div
              class="coupon-content-name blue"
              v-if="validCouponList.length > 0 && !chooseCoupon.userCouponId"
            >{{validCouponList.length}}张可用</div>
            <div class="coupon-content-name normal" v-if="chooseCoupon.userCouponId">
              [
              <span class="coupon-content-name-title">{{chooseCoupon.title}}</span>
              ]
              -￥{{moneyFormatGroup(chooseCoupon.discountPrice, 2)}}
            </div>
            <span class="icon iconfont">&#xe611;</span>
          </div>
        </div>
        <div class="total-price">
          合计：
          <span
            class="total-price-number"
          >￥{{moneyFormatGroup(getMinPrice(currentPrice.currentPrice - (chooseCoupon.discountPrice || 0)), 2)}}</span>
        </div>
      </div>
      <div class="description">
        <span class="remark">给机构留言</span>
        <textarea
          name=""
          id="remark"
          cols="30"
          rows="10"
          v-on:blur="inputBlur"
          maxlength="100"
          placeholder="请输入"
          v-model="memo"
        ></textarea>
      </div>
      <div class="footer">
        <span class="text">
          <span class="text-top">合计：¥{{moneyFormatGroup(getMinPrice(currentPrice.currentPrice - (chooseCoupon.discountPrice || 0)), 2)}}</span>
          <span class="text-bottom">已优惠：￥{{moneyFormatGroup(chooseCoupon.discountPrice, 2)}}</span>
        </span>
        <div class="submit" @click="submit">提交订单</div>
      </div>
    </div>
    <mt-popup v-model="openPopover" position="bottom">
      <div class="price-popup">
        <div class="header">
          <span class="cancel" @click="closeSelect">取消</span>
          <span class="title">选择收费标准</span>
          <span class="complete" @click="confirmPrice">完成</span>
        </div>
        <div class="price">
          <span class="money">¥{{moneyFormatGroup(selectedPrice.currentPrice, 2)}}</span>
          <span
            class="number"
          >{{(selectedPrice.commoditySpecs || {}).containQuantity}}{{(selectedPrice.commoditySpecs || {}).measurementUnits}}</span>
        </div>
        <div class="select">
          <ul>
            <li
              v-for="(item, index) in priceList"
              :key="index"
              @click="changePrice(item.id)"
              :class="item.id == selectedPrice.id ? 'item selected' : 'item'"
            >
              <span class="tag">{{item.specName}}</span>
            </li>
          </ul>
        </div>
      </div>
    </mt-popup>
    <xm-confirm
      :show="commodityDetail.state == 'CONFIG'"
      title
      message="商品已下架"
      :on-ok="onOk"
      :showCancle="false"
    ></xm-confirm>
    <ChooseCoupon
      :visible="showChooseCoupon"
      :validCouponList="validCouponList"
      :invalidCouponList="invalidCouponList"
      :chooseCoupon="chooseCoupon"
      @chooseEvent="handleChooseCoupon"
    ></ChooseCoupon>
  </div>
</template>
<script>
import { moneyFormatGroup } from "../../core/filters";
import User from "@/core/user";
import WechatApi from "@/core/wechatApi";
import ChooseCoupon from "./ChooseCoupon";

export default {
  components: {
    ChooseCoupon
  },
  data() {
    return {
      commodityDetail: {},
      priceList: [],
      currentPrice: {},
      selectedPrice: {},
      selected: "",
      memo: "",
      openPopover: false,
      studentInfo: {},
      objectId: "",
      list: [
        "课时定价标准1",
        "课时定价标准2",
        "课时定价标准3",
        "课时定价标准4"
      ],
      moneyFormatGroup,
      validCouponList: [], // 可使用的优惠券
      invalidCouponList: [], // 不可用的优惠券
      chooseCoupon: {}, // 选择的优惠券
      showChooseCoupon: false
    };
  },

  methods: {
    getMinPrice(price) {
      if (price > 0) {
        return price;
      }
      return 0;
    },
    fetchCommodityDetail() {
      const data = {
        commodityId: window.getParameterByName("commodityId"),
        instId: window.getParameterByName("mallInstId")
      };
      axios.Customer("anon/courseCommodity/getDetailById", data).then(res => {
        if (res.success) {
          this.selected = window.getParameterByName("specId");
          this.commodityDetail = res.result.commodityDetailVO;
          this.priceList = res.result.commoditySpecShowVOList;
          this.currentPrice = _.find(
            this.priceList,
            item => item.id == this.selected
          );
          this.selectedPrice = this.currentPrice;
        }
      });
    },

    fetchCouponLIst() {
      const data = {
        specId: window.getParameterByName("specId"),
        instId: window.getParameterByName("mallInstId"),
        studentId: window.getParameterByName("studentId")
      };
      axios
        .Customer("public/coupon/getOnlineStoreStudentCouponList", data)
        .then(res => {
          const validCouponList = res.result.validCouponList;
          this.invalidCouponList = res.result.invalidCouponList;
          this.validCouponList = validCouponList;
          if (validCouponList.length > 0) {
            this.chooseCoupon = res.result.validCouponList[0];
          }
        });
    },

    inputBlur() {
      document.body && (document.body.scrollTop = document.body.scrollTop);
    },

    onOk() {
      this.$router.replace({ name: "commodity_detail" });
    },

    jumpUrl(orderId) {
      // debugger;
      var flag = User.appId() != (APPID || "wxdd6b458500d4c224");
      let componentId = "wx34b8ca68dd4886db";
      if (location.host.indexOf("rc.xiaomai5") != -1) {
        componentId = "wxa56549a4098a9d32";
      }
      const host = `${window.CONFIG.payHost()}#/mallPay?orderId=${orderId}&xmToken=${User.token()}&userId=${User.uid()}&openId=${User.openId()}&appId=${APPID}&instId=${window.getParameterByName(
        "mallInstId"
      )}`;
      let reloadUrl = "";
      if (flag) {
        reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${User.appId()}&redirect_uri=${encodeURIComponent(
          host
        )}&component_appid=${componentId}&response_type=code&scope=snsapi_base#wechat_redirect`;
      } else {
        reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${User.appId()}&redirect_uri=${encodeURIComponent(
          host
        )}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;
      }
      return reloadUrl;
    },

    submit() {
      const data = {
        memo: this.memo,
        objectId: this.objectId,
        orderDetails: [
          {
            purchaseQuantity: 1,
            specId: this.currentPrice.id
          }
        ],
        studentId: window.getParameterByName("studentId"),
        userId: User.uid()
      };
      if (this.chooseCoupon.userCouponId) {
        data.orderPromotion = {
          userCouponId: this.chooseCoupon.userCouponId
        };
      }
      axios.Customer("public/customerOrder/create", data).then(res => {
        if (res.success) {
          window.location.href = this.jumpUrl(res.result.customerOrderVO.id);
        }
      });
    },

    selectPrice() {
      this.openPopover = true;
    },

    closeSelect() {
      this.openPopover = false;
      this.selectedPrice = this.currentPrice;
    },

    confirmPrice() {
      this.currentPrice = this.selectedPrice;
      this.selected = this.selectedPrice.id;
      this.openPopover = false;
    },

    changePrice(id) {
      this.selectedPrice = _.find(this.priceList, item => item.id == id);
    },

    doShare() {
      const list = User.getInstList();
      const inst = _.find(
        list,
        item => item.instId == window.getParameterByName("mallInstId")
      );
      inst &&
        WechatApi.doWapShare({
          title: `${inst.instName}有购课商城啦！`,
          desc: "线上购课，微信支付，免去排队烦恼，快来看看~~",
          linkUrl:
            location.origin +
            location.pathname +
            "#/mall/buyer?appid=" +
            User.appId() +
            "&mallInstId=" +
            inst.instId,
          imgUrl:
            inst.banner || "https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png"
        });
      inst && wx.miniProgram.postMessage({ data: {
            title: `${inst.instName}有购课商城啦！`,
            desc: "线上购课，微信支付，免去排队烦恼，快来看看~~",
            linkUrl:
              location.origin +
              location.pathname +
              "#/mall/buyer?appid=" +
              User.appId() +
              "&mallInstId=" +
              inst.instId,
            imgUrl:
              inst.banner || "https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png"
        } })
    },

    handleShowChooseCoupon() {
      if (this.validCouponList.length > 0) {
        this.showChooseCoupon = true;
      }
    },

    handleHideChooseCoupon() {
      this.showChooseCoupon = false;
    },

    handleChooseCoupon(item) {
      this.chooseCoupon = item;
      this.handleHideChooseCoupon();
    }
  },

  mounted() {
    this.studentInfo = User.getUserInfo() || {};
    this.objectId = randomString(32);
    this.fetchCommodityDetail();
    this.fetchCouponLIst();
    this.doShare();
  }
};
</script>

<style lang="less">
@import "../../core/mixins.less";
.order-confirm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  padding-bottom: 0.88rem;
  .student {
    background: #fff;
    height: 1.2rem;
    padding: 0.2rem 0.32rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    .avatar {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      margin-right: 0.24rem;
    }
    .name {
      font-size: 0.3rem;
      line-height: 0.42rem;
      max-height: 0.84rem;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .info {
    background: #fff;
    margin-bottom: 0.2rem;
    .inst {
      display: flex;
      padding: 0 0.32rem;
      align-items: center;
      height: 0.8rem;
      .icon {
        color: #999;
        font-size: 0.3rem;
        margin-right: 0.1rem;
      }
      .word {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #999;
        font-size: 0.26rem;
        max-width: ~"calc(100% - 0.48rem)";
        flex-shrink: 0;
      }
    }
    .box {
      height: 2rem;
      padding: 0.2rem 0.3rem;
      display: flex;
      position: relative;
      .image {
        width: 1.6rem;
        height: 1.6rem;
        margin-right: 0.3rem;
        object-fit: cover;
      }
      .detail {
        height: 1.6rem;
        width: ~"calc(100% - 1.9rem)";
        position: relative;
        .name {
          display: block;
          font-size: 0.3rem;
          color: #333;
          line-height: 0.42rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          width: ~"calc(100% - 0.8rem)";
        }
        .unit {
          position: absolute;
          width: 100%;
          bottom: 0;
          display: flex;
          justify-content: space-between;
          font-size: 0.3rem;
          line-height: 0.42rem;
          .number {
            color: #999;
          }
        }
      }
      .select-price {
        position: absolute;
        color: #dedede;
        right: 0;
        top: 0;
        padding: 0.1rem 0.2rem;
        z-index: 1;
        span {
          line-height: 0.4rem;
          font-size: 0.4rem;
        }
      }
    }
    .coupon-content {
      height: 0.92rem;
      padding: 0 0.3rem;
      .coupon-content-inner {
        .divide-bottom();
        .divide-top();
        width: 100%;
        height: 0.92rem;
        line-height: 0.92rem;
        display: flex;
        .icon {
          color: #dedede;
        }
        .coupon-content-name {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          &.gray {
            color: #999;
          }
          &.blue {
            color: #3296fa;
          }
          .coupon-content-name-title {
            overflow: hidden;
            max-width: 3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
          }
        }
      }
    }
    .total-price {
      height: 0.92rem;
      padding-right: 0.3rem;
      line-height: 0.92rem;
      text-align: right;
      color: #333;
      .total-price-number {
        color: #ff8534;
      }
    }
  }
  .description {
    background: #fff;
    padding: 0.24rem 0.32rem;
    text-align: left;
    .remark {
      display: block;
      text-align: left;
      color: #333;
      line-height: 0.42rem;
      font-size: 0.3rem;
      margin-bottom: 0.08rem;
    }
    textarea {
      border: none;
      width: 100%;
      height: 1.5rem;
    }
  }
  .footer {
    position: fixed;
    display: flex;
    justify-content: space-between;
    bottom: 0;
    left: 0;
    height: 1rem;
    width: 100%;
    background: #fff;
    .text {
      border-top: 1px solid #eee;
      height: 1rem;
      box-sizing: border-box;
      width: ~"calc(100% - 2.4rem)";
      text-align: left;
      display: flex;
      flex-direction: column;
      padding-left: 0.32rem;
      justify-content: center;
      .text-top {
        color: #666;
      }
      .text-bottom {
        color: #999;
        font-size: 0.22rem;
      }
    }
    .submit {
      width: 2.4rem;
      height: 1rem;
      background: #3296fa;
      color: #fff;
      text-align: center;
      line-height: 1rem;
      font-size: 0.3rem;
    }
  }
}
.price-popup {
  width: 100vw;
  .header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #eee;
    height: 0.88rem;
    .cancel {
      font-size: 0.3rem;
      color: #333;
    }
    .title {
      font-size: 0.34rem;
      color: #333;
    }
    .complete {
      font-size: 0.3rem;
      color: #3296fa;
    }
  }
  .price {
    height: 0.88rem;
    display: flex;
    align-items: center;
    margin: 0 0.3rem;
    border-bottom: 1px solid #eee;
    .money {
      font-size: 0.3rem;
      color: #ff8534;
      margin-right: 0.4rem;
    }
    .number {
      font-size: 0.3rem;
      color: #999;
      margin-right: 0.4rem;
    }
  }
  .select {
    padding: 0.32rem;
    padding-bottom: 0.8rem;
    ul {
      text-align: left;
      .item {
        display: inline-block;
        margin-right: 0.16rem;
        margin-bottom: 0.24rem;
        &.selected {
          .tag {
            color: #3296fa;
            border-color: #3296fa;
          }
        }
        .tag {
          padding: 0.04rem 0.16rem;
          color: #999;
          border: 1px solid #ddd;
          border-radius: 0.08rem;
          font-size: 0.28rem;
          line-height: 0.4rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/module/mall/OrderConfirm.vue